// extracted by mini-css-extract-plugin
export var card = "StatCallout-module--card--35438";
export var description = "StatCallout-module--description--4f212";
export var divider = "StatCallout-module--divider--eb46a";
export var stat = "StatCallout-module--stat--2f585";
export var statBlock = "StatCallout-module--statBlock--6bbdd";
export var statLabel = "StatCallout-module--statLabel--074f2";